import { storageManager, LocalStorageKeys } from './storageManager';

type Settings = {
	resetStartDateImmediately?: boolean;
};

class CacheManager {
	private readonly fieldKey: string;
	private readonly cacheTimeout: number;

	constructor(id: string, cacheTimeout: number, settings: Settings = {}) {
		this.fieldKey = id;
		this.cacheTimeout = cacheTimeout;

		if (settings.resetStartDateImmediately) {
			this.resetStartDate();
		}
	}

	getStartDate(): number | null {
		return storageManager.getSubItem<number>(LocalStorageKeys.CacheManager, this.fieldKey);
	}

	resetStartDate(): void {
		storageManager.setSubItem(LocalStorageKeys.CacheManager, this.fieldKey, Date.now());
	}

	hasInvalidateCacheTime(): boolean {
		const startDate = this.getStartDate();

		if (startDate === null) {
			this.resetStartDate();

			return false;
		}

		return Date.now() - startDate > this.cacheTimeout;
	}
}

export { CacheManager };
